export enum EndpointKeys {
  UseGetBusiness = 'getBusiness',
  UseGetBusinessEin = 'getBusinessEin',
}
